const MATRIZ_EXPOSICAO_IMPACTO = {
  IRRELEVANTE: 'IRRELEVANTE',
  INSIGNIFICANTE: 'INSIGNIFICANTE',
  MEDIO: 'MEDIO',
  CRITICO: 'CRITICO',
};

export default MATRIZ_EXPOSICAO_IMPACTO;
